import fisheryResource from "./fishery-resource.store";
import kadeeResource from "./kadee-resource.store";

export default {
    fisheryResource,
    kadeeResource,
};
